import { useAuth } from 'context/AuthContext';
import { useParams } from 'react-router';
import { WaitingListParams } from './useWaitingListURL';

export const useWaitingListMemberId = () => {
  const { memberId } = useParams<WaitingListParams>();
  const { sangixUser } = useAuth();
  return memberId || sangixUser!.main_member_id;
};
